import { LazyPageWrapper } from '@/components/optimization/LazyPageWrapper';
import { lazyWithRetry } from '@/utils/lazyWithRetry';

// Lazy load heavy pages with retry for better reliability on slow networks
export const LazyAdminBulkPatients = lazyWithRetry(() => import('@/pages/admin/AdminBulkPatients'));
export const LazyProfessionalAnalytics = lazyWithRetry(() => import('@/pages/ProfessionalAnalytics'));
export const LazyDecentralizedTrials = lazyWithRetry(() => import('@/pages/DecentralizedTrials'));
export const LazyRegulatoryCompliance = lazyWithRetry(() => import('@/pages/RegulatoryCompliance'));
export const LazySiteAssessment = lazyWithRetry(() => import('@/pages/SiteAssessment'));
export const LazyTrialManagement = lazyWithRetry(() => import('@/pages/TrialManagement'));
export const LazyAIEnhancements = lazyWithRetry(() => import('@/pages/AIEnhancements'));
export const LazyEducation = lazyWithRetry(() => import('@/pages/Education'));
export const LazyGamification = lazyWithRetry(() => import('@/pages/Gamification'));

// Wrapper components with appropriate fallbacks
export function AdminBulkPatientsLazy() {
  return (
    <LazyPageWrapper>
      <LazyAdminBulkPatients />
    </LazyPageWrapper>
  );
}


export function ProfessionalAnalyticsLazy() {
  return (
    <LazyPageWrapper>
      <LazyProfessionalAnalytics />
    </LazyPageWrapper>
  );
}

export function DecentralizedTrialsLazy() {
  return (
    <LazyPageWrapper>
      <LazyDecentralizedTrials />
    </LazyPageWrapper>
  );
}

export function RegulatoryComplianceLazy() {
  return (
    <LazyPageWrapper>
      <LazyRegulatoryCompliance />
    </LazyPageWrapper>
  );
}

export function SiteAssessmentLazy() {
  return (
    <LazyPageWrapper>
      <LazySiteAssessment />
    </LazyPageWrapper>
  );
}

export function TrialManagementLazy() {
  return (
    <LazyPageWrapper>
      <LazyTrialManagement />
    </LazyPageWrapper>
  );
}

export function AIEnhancementsLazy() {
  return (
    <LazyPageWrapper>
      <LazyAIEnhancements />
    </LazyPageWrapper>
  );
}

export function EducationLazy() {
  return (
    <LazyPageWrapper>
      <LazyEducation />
    </LazyPageWrapper>
  );
}

export function GamificationLazy() {
  return (
    <LazyPageWrapper>
      <LazyGamification />
    </LazyPageWrapper>
  );
}